import api from '../api';
import * as types from './mutation-types';
import cookie from '../util/cookie';
import util from '../util';

// 获取简历份数
export const getResumeCount = ({ commit, state }, userId) => {
	return api.getResumeCount(userId).then(res => {
		if (res.isSuccess) {
			commit(types.SET_RESUME_COUNT, res.entity.fulltimeCount);
		}
	});
};

// 获取上一份简历信息
export const getLastResumeInfo = ({ commit, state }) => {
	return api.getLastResumeInfo().then(res => {
		if (res.isSuccess) {
			commit(types.CHANGE_BASICINFO, {
				key: 'pic',
				value: res.entity.picUrl
			});
			// 基础信息(必传)
			let basicInfo = {
				truename: res.entity.trueName,
				gender: res.entity.gender,
				birthday: res.entity.birthday,
				education: res.entity.education,
				workyears: res.entity.workYears
			};

			for (let key in basicInfo) {
				commit(types.CHECK_BASICINFO, {
					key: key,
					value: basicInfo[key],
					state: true
				});
			}
			// 修改教育经历
			commit(types.CHECK_BASICINFO, {
				key: 'educations',
				value: JSON.stringify(res.entity.educations || []).replace(
					/profession/g,
					'professional'
				),
				state: res.entity.educations && res.entity.educations.length > 0
			});

			// 非必填字段
			let otherInfo = {
				pic: res.entity.picUrl || ''
			};

			for (let key in otherInfo) {
				commit(types.CHANGE_BASICINFO, {
					key: key,
					value: otherInfo[key]
				});
			}

			// 如果存在期望信息
			if (res.entity.cateIds) {
				// 期望页面字段
				let expectInfo = {
					zpcateId: res.entity.cateIds, // 期望职位(测试)
					salary: res.entity.salaryId, //期望薪资
					targetAreaId: res.entity.targetAraeId //意向工作地点（测试）
				};

				for (let key in expectInfo) {
					commit(types.CHECK_EXPECTIONINFO, {
						key: key,
						value: expectInfo[key],
						state: true
					});
				}
			}

			// 如果存在期望信息数组
			if (res.entity.infoCates && res.entity.infoCates.length > 0) {
				// 期望页面字段
				let expectInfo = {
					sessionCateList: res.entity.infoCates, // 期望职位(测试)
					sessionAreaList: res.entity.targetAreas //意向工作地点（测试）
				};

				for (let key in expectInfo) {
					commit(types.CHANGE_OPTION, {
						key: key,
						value: expectInfo[key]
					});
				}
			}
		}
	});
};

// 获取区域
export const getAreaInfo = ({ commit, state }) => {
	let cityname = util.getParamVal('topArea') || cookie.get('mcity') || '';
	return api.getAreaInfo(cityname).then(res => {
		if (res.code === 0) {
			commit(types.SET_AREA_DATA, res.object);
		}
	});
};

// 获取账号绑定的手机号，且校验手机号是否认证
export const checkMobileAuth = ({ commit, state }, mobile = '') => {
	// 手机号正确
	if (mobile !== '') {
		commit('CHECK_BASICINFO', {
			key: 'mobile',
			value: mobile,
			state: true
		});
	}
	return api
		.checkMobileAuth(mobile)
		.then(res => {
			if (res.isSuccess) {
				// 初始化调用无手机号，则将返回的手机号存储到submitdata中并修改信息填写状态
				if (mobile === '' && res.entity.authMobile !== '') {
					commit('CHECK_BASICINFO', {
						key: 'mobile',
						value: res.entity.authMobile,
						state: true
					});
				}
				// 已认证
				if (res.entity.auth) {
					commit('CHECK_BASICINFO', {
						key: 'keyCode',
						value: '',
						state: true
					});
				} else {
					commit('CHECK_BASICINFO', {
						key: 'keyCode',
						value: '',
						state: false
					});
				}
				commit(types.CHANGE_HASAUTHED, res.entity);
			}
		})
		.catch(e => {
			console.log(e);
		});
};

// 获取手机验证码
export const getCheckCode = ({ commit, state }, mobile) => {
	return api
		.getCheckCode(mobile)
		.then(res => {
			if (res.isSuccess) {
				state.captcha.responseid = res.entity.responseid;
				state.submitData.responseid = res.entity.responseid;
			} else {
				state.captcha.errorInfo = res.returnMessage;
			}
			state.captcha.isSuccess = res.isSuccess; // 验证码获取状态
		})
		.catch(e => {
			state.captcha.isSuccess = false;
			state.captcha.errorInfo = '网络异常，请稍后重试';
		});
};

// 验证手机验证码
export const verifyCheckCode = ({ commit, state }, params) => {
	return api
		.verifyCheckCode(params.mobile, params.code, state.captcha.responseid)
		.then(res => {
			if (res.isSuccess) {
				commit(types.CHECK_BASICINFO, {
					key: 'keyCode',
					value: params.code,
					state: true
				});

				// 存储为已认证的手机号
				commit(types.SET_HASAUTHEDMOBILE, params.mobile);
			} else {
				commit(types.CHECK_BASICINFO, {
					key: 'keyCode',
					value: params.code,
					state: false
				});
			}
		})
		.catch(e => { });
};

// 头像上传
export const uploadImg = async ({ commit, state }, params) => {
	const imgData = params.dataUrl;

	try {
		let res = await api.getUploadUrl();

		const { data, code } = res;
		if (code) {
			commit('CHANGE_UPLOAD_STATE', {
				state: false,
				picUrl: ''
			});
			return;
		}

		const uploadUrl = data[0].url;
		const fileName = data[0].fileName;
		const imgUrl = 'https://pic1.58cdn.com.cn/nowater/resume/' + fileName;
		
		let picRes = await api.uploadPic({ imgData: util.dataURLtoBlob(imgData, fileName), uploadUrl });
		if(picRes.status===200){
			if (params.isOrigin) {
				state.originPic = imgUrl;
			} else {
				commit('CHANGE_UPLOAD_STATE', {
					state: true,
					picUrl: imgUrl
				});
			}
		}
	} catch (error) {
		console.error('upload error:', error);

		commit('CHANGE_UPLOAD_STATE', {
			state: false,
			picUrl: ''
		});
	}
};

// 简历发布
export const saveResume = ({ commit, state }) => {
	// 非(大专及以上 + 校招 + 应届生)，教育经历置空
	if (
		!(
			state.submitData.education > 3 &&
			(state.pagefrom === 'fromXZ' || state.pagefrom === 'fromCQXZ') &&
			state.submitData.workyears === 5
		)
	) {
		commit(types.CHECK_BASICINFO, {
			key: 'educations',
			value: JSON.stringify([]),
			state: true
		});
	}
	return api
		.saveResume(state.submitData)
		.then(res => {
			// 发布成功
			if (res.code === 0) {
				commit(types.CHANGE_SUBMITSTATE, {
					submitState: true,
					resumeId: res.data.resumeId,
					submitErrorInfo: ''
				});
			} else if (res.code === 13000002) { //简历分数达到上限3份
				commit(types.SET_RESUME_COUNT, 3);
			} else if (res.code === 13000029) {
				// 出滑块验证码
				commit(types.CHANGE_SUBMITSTATE, {
					submitState: false,
					responseObj: res.data
				});
			} else if (res.code === 13000030) {
				// 跳转个人认证页面（目前后端已加入白名单，小程序走不到该逻辑）
				location.href =
					'https://authlist.58.com/authcustom/index?pId=2&appId=OLKcIUMVRg&callbackurl=' +
					encodeURIComponent(
						location.origin +
						location.pathname +
						location.search +
						'&comefrom=auth' +
						location.hash
					);
				return false;
			} else if (res.code === 302) {
				// 简历发布频繁
				location.href = res.data.url;
				return false;
			} else {
				let message = res.message || '网络异常，请稍后重试';
				commit(types.CHANGE_SUBMITSTATE, {
					submitState: false,
					resumeId: '',
					submitErrorInfo: message
				});
			}
		})
		.catch(e => {
			commit(types.CHANGE_SUBMITSTATE, {
				submitState: false,
				resumeId: '',
				submitErrorInfo:
					e.message.split(':')[1] || '网络异常，请稍后重试'
			});
		});
};

// 获取用户隐私设置
export const getPrivacy = ({ commit, state }) => {
	return api.getPrivacy().then(res => {
		if (res.code === 0) {
			commit(types.SET_PRIVACY, {
				key: 'showStatus',
				value: res.object.showStatus
			});
			commit(types.SET_PRIVACY, {
				key: 'blockIndustry',
				value: res.object.blockIndustry
			});
		}
	});
};

// 保存隐私设置
export const setPrivacy = ({ commit, state }) => {
	return api
		.setPrivacy(state.privacyData)
		.then(res => {
			if (res.code === 0) {
				state.privacySettingState = true;
			} else {
				state.privacySettingState = false;
				state.privacyErrorInfo = res.message;
			}
		})
		.catch(e => {
			state.privacySettingState = false;
			state.privacyErrorInfo = e.message;
		});
};

// 投递操作
export const delivery = ({ commit, state }) => {
	let params = state.deliveryObj;
	params.resumeId = state.resumeId;
	return api
		.delivery(params)
		.then(res => {
			let successCode = [
				12000011,
				12000012,
				12000013,
				12000014,
				12000015,
				12000016,
				12000017,
				12000018
			];

			// 投递结果code
			state.deliveryCode = res.code;

			// 成功回调
			if (successCode.indexOf(res.code) > -1) {
				state.deliveryState = true;
			} else {
				state.deliveryMsg = res.msg;
				state.deliveryState = false;
			}
		})
		.catch(e => {
			state.deliveryState = false;
		});
};



// WEBPACK FOOTER //
// ./src/module/basic/store/actions.js